import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dd56ce4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "row g-0" }
const _hoisted_3 = { class: "col-md-6 col-sm-12 col-xs-12 col-sm-0 position-relative" }
const _hoisted_4 = { class: "img-wrapper position-relative" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "tl-badges position-absolute d-flex" }
const _hoisted_7 = ["data-bs-toggle", "data-bs-title"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-alt-to-bottom" })
], -1))
const _hoisted_9 = ["data-bs-toggle", "data-bs-title"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-heart" })
], -1))
const _hoisted_11 = { class: "br-badges position-absolute author-badge px-2 py-1 rounded-1 shadow-sm" }
const _hoisted_12 = { class: "game-logo position-absolute" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "col-md-6 col-sm-12 col-xs-12" }
const _hoisted_15 = { class: "card-body h-100 d-grid align-content-between" }
const _hoisted_16 = { class: "d-flex flex-column overflow-auto" }
const _hoisted_17 = { class: "my-1" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "d-flex justify-content-end mt-3" }
const _hoisted_20 = ["data-bs-toggle", "data-bs-title"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-black me-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-eye" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _ctx.previewPic(_ctx.data.img),
            class: "item-pic img-fluid rounded-start",
            alt: _ctx.data.title
          }, null, 8, _hoisted_5),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "downloads-badge px-2 py-1 rounded-1 shadow-sm",
              "data-bs-toggle": `tooltip-${_ctx.data.id}`,
              "data-bs-placement": "top",
              "data-bs-title": _ctx.getStringDownloads(_ctx.data.downloads)
            }, [
              _hoisted_8,
              _createTextVNode(_toDisplayString(_ctx.getEyeCandyNum(_ctx.data.downloads)), 1)
            ], 8, _hoisted_7),
            _createElementVNode("div", {
              class: "rating-badge px-2 ms-2 py-1 rounded-1 shadow-sm",
              "data-bs-toggle": `tooltip-${_ctx.data.id}`,
              "data-bs-placement": "top",
              "data-bs-title": _ctx.getStringLikes(_ctx.data.likes)
            }, [
              _hoisted_10,
              _createTextVNode(_toDisplayString(_ctx.getEyeCandyNum(_ctx.data.likes)), 1)
            ], 8, _hoisted_9)
          ]),
          _createElementVNode("div", _hoisted_11, " Автор: " + _toDisplayString(_ctx.data.author), 1),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("img", {
              alt: "game-logo",
              src: _ctx.itemGameLogo(_ctx.data.game)
            }, null, 8, _hoisted_13)
          ])
        ]),
        _createVNode(_component_router_link, {
          to: { name: 'mod', params: { game: _ctx.data.game, slug: _ctx.data.slug }},
          class: "img-wrapper_action position-absolute"
        }, null, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_router_link, {
              to: { name: 'mod', params: { game: _ctx.data.game, slug: _ctx.data.slug }},
              class: "card-link text-wrap"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.data.title), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _createElementVNode("small", _hoisted_17, "Загружено • " + _toDisplayString(_ctx.getStringTimestamp(_ctx.data.timestamp)), 1),
            _createElementVNode("div", {
              class: "description no-style text-brake",
              innerHTML: _ctx.data.description
            }, null, 8, _hoisted_18)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", {
              class: "views text-center me-2 px-3",
              "data-bs-toggle": `tooltip-${_ctx.data.id}`,
              "data-bs-placement": "top",
              "data-bs-title": _ctx.getStringViews(_ctx.data.views)
            }, [
              _hoisted_21,
              _createTextVNode(_toDisplayString(_ctx.getEyeCandyNum(_ctx.data.views)), 1)
            ], 8, _hoisted_20),
            _createVNode(_component_router_link, {
              tag: "button",
              to: { name: 'mod', params: { game: _ctx.data.game, slug: _ctx.data.slug }},
              class: "btn btn-card py-0 px-3 text-nowrap"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Открыть")
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ])
    ])
  ]))
}